/** Human-readable byte size in the viewer's locale */

export function formatBytes(bytes: number, locale: string): string {
  if (bytes < 1024) return `${bytes} B`
  const kb = bytes / 1024
  if (kb < 1024) return `${kb.toLocaleString(locale, { maximumFractionDigits: 1 })} KB`
  return `${(kb / 1024).toLocaleString(locale, { maximumFractionDigits: 1 })} MB`
}
